import React, { Component } from 'react';
import { Upload, Button, Icon } from 'antd';
import { remove, indexOf } from 'ramda';

import withFormItem from 'components/hocs/withFormItem';

@withFormItem
export default class InputComponent extends Component {
    state = {
        files: []
    }

    onRemove = (file) => {
        const index = indexOf(file, this.state.files);
        const files = remove(index, 1, this.state.files);

        this.setState({
            files
        });

        const { field: { name }, form: { setFieldValue } } = this.props;

        setFieldValue(
            name,
            files
        );

        return false;
    }

    onChange = (file) => {
        const files = [
            ...this.state.files,
            file
        ];

        this.setState({
            files
        });

        const { field: { name }, form: { setFieldValue } } = this.props;

        setFieldValue(
            name,
            files
        );

        return false;
    }

    render() {
        const { field: { name } } = this.props;

        return (
            <div className="files-input">
                <Upload
                    fileList={this.state.files}
                    name={name}
                    beforeUpload={this.onChange}
                    onRemove={this.onRemove}
                >
                    <Button>
                        Добавить файлы
                        <Icon type="arrow-down" />
                    </Button>
                </Upload>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/form/Files.js